import { cn } from '@/lib/utils'
import { ButtonIcon } from '@/ui/components'
import { memo } from 'react'

export interface SliderArrowsProps {
  scrollPrev?: () => void
  scrollNext?: () => void
  disabledPrev?: boolean
  disabledNext?: boolean
  showArrows?: boolean
  navigationHidden?: boolean
  className?: string
  props?: React.HTMLAttributes<HTMLDivElement>
  arrowPosition?: 'top-right' | 'bottom-right'
}

const SliderArrows = ({
  scrollPrev,
  scrollNext,
  disabledPrev,
  disabledNext,
  showArrows,
  navigationHidden,
  className,
  arrowPosition,
  props
}: SliderArrowsProps) => {
  !showArrows && navigationHidden && null

  return (
    <div
      className={cn('gap-2xs z-5 flex justify-end max-md:hidden', className)}
      data-arrows
      {...props}
    >
      <ButtonIcon
        onClick={scrollPrev}
        disabled={disabledPrev}
        className="cursor-pointer"
        icon="material-symbols:arrow-back-ios-new"
        size="m"
        aria-label="Previous slide"
      />

      <ButtonIcon
        onClick={scrollNext}
        disabled={disabledNext}
        icon="material-symbols:arrow-forward-ios"
        className="cursor-pointer"
        size="m"
        aria-label="Next slide"
      />
    </div>
  )
}

SliderArrows.displayName = 'SliderArrows'

export default memo(SliderArrows)
